import { __assign } from "tslib";
import { createFakePutResponder } from './../../test-utils';
import { createFakeGetResponder } from '../../test-utils';
// tslint:disable-next-line:max-line-length
import { createEmailTemplatesApi } from './index';
import { createHttpTestKit } from '../../http/test-kit';
export var createEmailTemplatesApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createEmailTemplatesApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetEmailTemplates: function (dto) {
            return createFakeGetResponder(fakeHttp, "/emailTemplates/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        whenGetEmailTemplate: function (dto) {
            return createFakeGetResponder(fakeHttp, "/emailTemplates/" + dto.locale + "/" + dto.type + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        whenUpdateEmailTemplate: function (dto) {
            return createFakePutResponder(fakeHttp, "/emailTemplates/" + dto.locale + "/" + dto.type)(dto.data);
        },
        whenGetDefaultEmailTemplate: function (dto) {
            return createFakeGetResponder(fakeHttp, "/emailTemplates/" + dto.locale + "/" + dto.type + "/default" + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        whenEnableEmailTemplate: function (dto) {
            return createFakePutResponder(fakeHttp, "/emailTemplates/notifications/" + dto.locale + "/" + dto.type + "/enable" + (dto.brandId ? "?brandId=" + dto.brandId : ''))({});
        },
        whenDisableEmailTemplate: function (dto) {
            return createFakePutResponder(fakeHttp, "/emailTemplates/notifications/" + dto.locale + "/" + dto.type + "/disable" + (dto.brandId ? "?brandId=" + dto.brandId : ''))({});
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map